(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oppo-enco-x4-ai-clear-call"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('enco-x4-ai-clear-call'))customElements.define('enco-x4-ai-clear-call',class extends HTMLElement{
  connectedCallback(){
    const boot=()=>{if(!this.isConnected||this.events||!this.querySelector('[data-cc-end]'))return;this.readyObserver?.disconnect();this.initialize();};
    this.readyObserver=new MutationObserver(boot);this.readyObserver.observe(this,{childList:true,subtree:true});queueMicrotask(boot);
  }
  initialize(){
    this.events=new AbortController();const options={signal:this.events.signal};this.sequence=(this.sequence||0)+1;
    this.buttons=[...this.querySelectorAll('[data-cc-button]')];this.optionsList=[...this.querySelectorAll('[data-cc-option]')];this.panels=[...this.querySelectorAll('[data-cc-panel]')];
    this.videoStates=new WeakMap();this.mediaVisible=false;this.reducedMotion=matchMedia('(prefers-reduced-motion:reduce)');
    this.pauseVideo=video=>{if(!video.paused){this.videoStates.get(video).automaticPause=true;video.pause();}};
    this.syncVideo=()=>this.panels.forEach(panel=>panel.querySelectorAll('video').forEach(video=>{
      const state=this.videoStates.get(video),active=panel.dataset.ccPanel===this.dataset.selected;
      if(!active||!this.mediaVisible||document.hidden){this.pauseVideo(video);return;}
      if(panel.dataset.ccVideoAutoplay==='true'&&!this.reducedMotion.matches&&!state.userPaused&&video.paused)video.play().catch(()=>{});
    }));
    this.querySelectorAll('.cc-switch-video').forEach(video=>{
      this.videoStates.set(video,{automaticPause:false,userPaused:false});
      video.addEventListener('pause',()=>{const state=this.videoStates.get(video);if(state.automaticPause){state.automaticPause=false;return;}if(!video.ended)state.userPaused=true;},options);
      video.addEventListener('play',()=>{this.videoStates.get(video).userPaused=false;const panel=video.closest('[data-cc-panel]');if(panel.dataset.ccPanel!==this.dataset.selected)this.pauseVideo(video);},options);
    });
    this.panels.forEach(panel=>panel.inert=panel.dataset.ccPanel!==this.dataset.selected);
    const media=this.querySelector('.cc-switch-media');
    this.videoObserver=new IntersectionObserver(entries=>{this.mediaVisible=entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>=.05);this.syncVideo();},{threshold:[0,.05]});
    if(media)this.videoObserver.observe(media);
    this.reducedMotion.addEventListener('change',()=>{if(this.reducedMotion.matches)this.querySelectorAll('.cc-switch-video').forEach(this.pauseVideo);else this.syncVideo();},options);
    document.addEventListener('visibilitychange',this.syncVideo,options);
    const walker=document.createTreeWalker(this,NodeFilter.SHOW_TEXT);let node;while((node=walker.nextNode()))node.nodeValue=node.nodeValue.normalize('NFC');
    this.addEventListener('click',event=>{const button=event.target.closest('[data-cc-button]');if(button&&this.contains(button))this.select(button.dataset.ccButton);},options);
    this.addEventListener('keydown',event=>{const button=event.target.closest('[data-cc-button]'),index=this.buttons.indexOf(button);if(index<0||!['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?this.buttons.length-1:(index+(['ArrowDown','ArrowRight'].includes(event.key)?1:-1)+this.buttons.length)%this.buttons.length;this.buttons[next].focus();this.select(this.buttons[next].dataset.ccButton);},options);
    this.addEventListener('shopify:block:select',event=>{const option=event.target.closest('[data-cc-option]');if(option)this.select(option.dataset.ccOption);},options);
    this.addEventListener('error',event=>{if(event.target instanceof HTMLImageElement)event.target.hidden=true;},{...options,capture:true});
    this.querySelectorAll('img').forEach(image=>{if(image.complete&&!image.naturalWidth)image.hidden=true;});
    this.fitCards=()=>{
      this.layoutFrame=0;
      this.querySelectorAll('.cc-card').forEach(card=>{
        const style=getComputedStyle(card),key=matchMedia('(max-width:749px)').matches?'--cc-mobile-ratio':'--cc-image-ratio';
        const [w,h]=style.getPropertyValue(key).split('/').map(Number),height=card.clientWidth/(w/h);
        card.classList.toggle('cc-long-copy',card.querySelector('.cc-card-copy').offsetHeight>height*.9);
      });
    };
    this.queueFit=()=>{if(!this.layoutFrame)this.layoutFrame=requestAnimationFrame(this.fitCards);};
    this.cardObserver=new ResizeObserver(this.queueFit);this.querySelectorAll('.cc-card-copy').forEach(copy=>this.cardObserver.observe(copy));
    window.addEventListener('resize',this.queueFit,{...options,passive:true});
    document.fonts?.ready.then(()=>{if(this.isConnected&&this.events)this.queueFit();});this.fitCards();this.dataset.ready='true';
  }
  async select(index){
    if(!this.buttons.some(button=>button.dataset.ccButton===index))return;
    const sequence=++this.sequence;if(this.dataset.selected===index){this.removeAttribute('aria-busy');this.syncVideo();return;}
    this.setAttribute('aria-busy','true');let timer;
    const images=[...this.querySelectorAll('[data-cc-panel="'+index+'"] img')];
    await Promise.race([Promise.allSettled(images.map(image=>{image.loading='eager';return image.decode();})),new Promise(resolve=>{timer=setTimeout(resolve,5000);})]);clearTimeout(timer);
    if(!this.isConnected||sequence!==this.sequence)return;
    this.dataset.selected=index;
    this.optionsList.forEach(option=>{const active=option.dataset.ccOption===index;option.dataset.selected=String(active);option.querySelector('.cc-button').setAttribute('aria-expanded',String(active));option.querySelector('.cc-option-body').hidden=!active;});
    this.panels.forEach(panel=>{const active=panel.dataset.ccPanel===index;panel.dataset.selected=String(active);panel.setAttribute('aria-hidden',String(!active));panel.inert=!active;});
    this.syncVideo();
    this.querySelector('.cc-status').textContent=this.buttons.find(button=>button.dataset.ccButton===index).textContent;this.removeAttribute('aria-busy');
  }
  disconnectedCallback(){this.videoObserver?.disconnect();this.querySelectorAll('.cc-switch-video').forEach(video=>video.pause());this.sequence=(this.sequence||0)+1;this.events?.abort();this.events=null;this.readyObserver?.disconnect();this.cardObserver?.disconnect();cancelAnimationFrame(this.layoutFrame);this.layoutFrame=0;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oppo-enco-x4-dynaudio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('enco-x4-dynaudio')) {
  customElements.define('enco-x4-dynaudio', class extends HTMLElement {
    connectedCallback() {
      const boot=()=>{
        if(!this.isConnected||this.events||!this.querySelector('[data-ed-end]'))return;
        this.readyObserver?.disconnect();this.initialize();
      };
      this.readyObserver=new MutationObserver(boot);this.readyObserver.observe(this,{childList:true,subtree:true});queueMicrotask(boot);
    }
    initialize() {
      this.events=new AbortController();const options={signal:this.events.signal,passive:true};
      const get=s=>this.querySelector(s);
      this.firstTrack=get('.ed-track--first');this.firstStage=get('.ed-stage--first');this.firstFrame=get('.ed-frame--first');
      this.logoBox=get('.ed-logo');this.firstShade=get('.ed-shade--first');this.bottomShade=get('.ed-bottom-shade');this.firstCopy=get('.ed-bottom-copy');
      this.secondTrack=get('.ed-track--second');this.secondStage=get('.ed-stage--second');this.secondShade=get('.ed-shade--second');this.secondCopy=get('.ed-center-copy');
      this.partsCanvas=get('.ed-parts');this.parts=[...this.querySelectorAll('[data-ed-part]')];this.referenceParts=[...this.querySelectorAll('[data-ed-reference-part]')];
      const walker=document.createTreeWalker(this,NodeFilter.SHOW_TEXT);let node;while((node=walker.nextNode()))node.nodeValue=node.nodeValue.normalize('NFC');
      this.host=window;let blocked=false;
      for(let p=this.parentElement;p&&p!==document.body;p=p.parentElement){
        const overflow=getComputedStyle(p).overflowY;
        if(/auto|scroll/.test(overflow)){this.host=p;break;}
        if(overflow==='hidden')blocked=true;
      }
      this.dataset.pin=blocked?'manual':'native';this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.queue=()=>{if(!this.raf)this.raf=requestAnimationFrame(()=>{this.raf=0;this.paint();});};
      this.resize=()=>{clearTimeout(this.resizeTimer);this.resizeTimer=setTimeout(()=>{if(this.isConnected)this.measure();},100);};
      this.host.addEventListener('scroll',this.queue,options);if(this.host!==window)window.addEventListener('scroll',this.queue,options);
      window.addEventListener('resize',this.resize,options);this.motion.addEventListener('change',this.resize,options);
      this.observer=new ResizeObserver(entries=>{if(Math.abs(entries[0].contentRect.width-(this.width||0))>1)this.resize();});this.observer.observe(this);
      this.copyObserver=new ResizeObserver(this.resize);this.copyObserver.observe(this.firstCopy);this.copyObserver.observe(this.secondCopy);
      document.fonts?.ready.then(()=>{if(this.isConnected&&this.events)this.measure();});
      this.measure();this.dataset.ready='true';
    }
    measure() {
      this.animated=this.dataset.motion!=='static'&&!(this.dataset.motion==='system'&&this.motion.matches);
      this.classList.toggle('ed-animated',this.animated);
      const width=this.clientWidth;if(!width)return;
      this.mobile=width<750;
      const viewport=this.host===window?window.innerHeight:this.host.clientHeight;
      if(!this.viewport||!this.mobile||Math.abs(width-this.width)>1||Math.abs(viewport-this.viewport)>140)this.viewport=viewport;
      this.width=width;this.offset=Math.min(this.viewport*.3,Math.max(0,Number(this.mobile?this.dataset.mobileOffset:this.dataset.offset)||0));
      this.height=Math.max(240,this.viewport-this.offset);
      this.zoomTravel=this.height*(Number(this.dataset.zoomDistance)||70)/100;
      this.copyTravel=this.height*(Number(this.dataset.copyDistance)||35)/100;
      this.firstHold=this.height*Math.max(0,Number(this.dataset.firstHold)||0)/100;
      this.secondHold=this.height*Math.max(0,Number(this.dataset.secondHold)||0)/100;
      this.firstTravel=this.zoomTravel+this.copyTravel+this.firstHold;
      this.style.setProperty('--ed-height',this.height+'px');this.style.setProperty('--ed-offset',this.offset+'px');
      this.style.setProperty('--ed-first-track',this.height+this.firstTravel+'px');this.style.setProperty('--ed-second-track',this.height+this.secondHold+'px');
      this.classList.remove('ed-long-first','ed-long-second');
      // Exceptionally long text uses normal flow so all uploaded copy remains readable.
      this.longFirst=this.animated&&this.firstCopy.offsetHeight>this.height*.72;
      this.classList.toggle('ed-long-first',this.longFirst);
      if(this.longFirst){this.firstStage.style.position='relative';this.firstTrack.style.height='auto';}
      else{this.firstStage.style.removeProperty('position');this.firstTrack.style.removeProperty('height');}
      this.longSecond=this.animated&&this.secondCopy.offsetHeight>this.height*.72;
      this.classList.toggle('ed-long-second',this.longSecond);
      if(this.longSecond){this.secondStage.style.position='relative';this.secondTrack.style.height='auto';}
      else{this.secondStage.style.removeProperty('position');this.secondTrack.style.removeProperty('height');}
      this.paint();
    }
    paint() {
      const clamp=n=>Math.max(0,Math.min(1,n)),smooth=n=>{const p=clamp(n);return p*p*(3-2*p);};
      const hostTop=this.host===window?0:this.host.getBoundingClientRect().top+this.host.clientTop;
      const distance=track=>hostTop+this.offset-track.getBoundingClientRect().top;
      let expand=1,reveal=1,entry=1;
      if(this.animated){
        const d=distance(this.firstTrack);expand=smooth(d/this.zoomTravel);reveal=smooth((d-this.zoomTravel)/this.copyTravel);
        entry=smooth((this.height+distance(this.secondTrack))/this.height);
        if(this.dataset.pin==='manual'){
          this.firstStage.style.transform=this.longFirst?'none':'translate3d(0,'+Math.max(0,Math.min(this.firstTravel,d))+'px,0)';
          this.secondStage.style.transform=this.longSecond?'none':'translate3d(0,'+Math.max(0,Math.min(this.secondHold,distance(this.secondTrack)))+'px,0)';
        }else{this.firstStage.style.removeProperty('transform');this.secondStage.style.removeProperty('transform');}
      }else{this.firstStage.style.removeProperty('transform');this.secondStage.style.removeProperty('transform');}
      if(this.longFirst){expand=1;reveal=1;}
      if(this.longSecond)entry=1;
      const initial=Math.max(.6,Math.min(.95,(Number(this.dataset.startScale)||80)/100));
      this.firstFrame.style.transform='scale('+(initial+(1-initial)*expand)+')';
      this.firstFrame.style.borderRadius=24*(1-expand)+'px';
      const logoOpacity=this.animated?1-smooth((expand-.78)/.22):0;
      this.logoBox.style.opacity=logoOpacity;this.logoBox.style.visibility=logoOpacity>0?'visible':'hidden';
      this.firstShade.style.opacity=.2*(1-expand);this.bottomShade.style.opacity=reveal;
      this.firstCopy.style.opacity=reveal;this.firstCopy.style.transform='translateY('+24*(1-reveal)+'px)';
      this.secondShade.style.opacity=(Number(this.dataset.darkness)||70)/100*entry;
      const textOpacity=this.animated?smooth((entry-.28)/.6):1;this.secondCopy.style.opacity=textOpacity;
      const stageTop=this.partsCanvas.getBoundingClientRect().top;
      const span=this.height*(Number(this.dataset.explodeDistance)||70)/100;
      const explode=this.animated?smooth((hostTop+this.viewport-stageTop)/span):1;
      const strength=(Number(this.dataset.explodeStrength)||100)/100;
      this.parts.forEach(part=>{
        const data=part.dataset,sx=Number(data.startX),sy=Number(data.startY);
        const ex=Number(this.mobile?data.mobileEndX:data.endX),ey=Number(this.mobile?data.mobileEndY:data.endY);
        const amount=explode*strength;
        part.style.setProperty('--ed-x',sx+(ex-sx)*amount+'%');part.style.setProperty('--ed-y',sy+(ey-sy)*amount+'%');
        part.style.setProperty('--ed-rotation',Number(data.startRotation)+(Number(data.endRotation)-Number(data.startRotation))*explode+'deg');
      });
      this.referenceParts.forEach(part=>{
        const remaining=1-explode*strength;
        part.setAttribute('transform','translate('+(Number(part.dataset.shiftX)*remaining).toFixed(3)+' '+(Number(part.dataset.shiftY)*remaining).toFixed(3)+')');
      });
      this.dataset.expand=expand.toFixed(4);this.dataset.reveal=reveal.toFixed(4);this.dataset.dim=entry.toFixed(4);this.dataset.explode=explode.toFixed(4);
    }
    disconnectedCallback(){this.events?.abort();this.events=null;this.readyObserver?.disconnect();this.observer?.disconnect();this.copyObserver?.disconnect();cancelAnimationFrame(this.raf);this.raf=0;clearTimeout(this.resizeTimer);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oppo-enco-x4-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('enco-x4-product'))customElements.define('enco-x4-product',class extends HTMLElement{
  connectedCallback(){
    const boot=()=>{if(!this.isConnected||this.events||!this.querySelector('[data-ec-end]'))return;this.readyObserver?.disconnect();this.initialize();};
    this.readyObserver=new MutationObserver(boot);this.readyObserver.observe(this,{childList:true,subtree:true});queueMicrotask(boot);
  }
  initialize(){
    this.events=new AbortController();const options={signal:this.events.signal};this.sequence=(this.sequence||0)+1;
    this.buttons=[...this.querySelectorAll('[data-variant-button]')];this.panels=[...this.querySelectorAll('[data-variant-panel]')];
    const walker=document.createTreeWalker(this,NodeFilter.SHOW_TEXT);let node;while((node=walker.nextNode()))node.nodeValue=node.nodeValue.normalize('NFC');
    this.addEventListener('click',event=>{const button=event.target.closest('[data-variant-button]');if(button&&this.contains(button))this.select(button.dataset.variantButton);},options);
    this.addEventListener('keydown',event=>{const button=event.target.closest('[data-variant-button]'),index=this.buttons.indexOf(button);if(index<0||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?this.buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+this.buttons.length)%this.buttons.length;this.buttons[next].focus();this.select(this.buttons[next].dataset.variantButton);},options);
    this.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-variant-panel]');if(panel)this.select(panel.dataset.variantPanel);},options);
    this.addEventListener('error',event=>{if(event.target instanceof HTMLImageElement)event.target.hidden=true;},{...options,capture:true});
    this.querySelectorAll('img').forEach(img=>{if(img.complete&&!img.naturalWidth)img.hidden=true;});
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;
    this.updateRipple=()=>{this.dataset.ripple=this.dataset.waveEnabled!=='true'?'off':this.motion.matches?'static':this.visible&&!document.hidden?'running':'paused';};
    this.motion.addEventListener('change',this.updateRipple,options);document.addEventListener('visibilitychange',this.updateRipple,options);
    this.observer=new IntersectionObserver(entries=>{this.visible=entries.some(entry=>entry.isIntersecting);this.updateRipple();},{threshold:.05});this.observer.observe(this.querySelector('.ec-wave-stage'));
    this.updateRipple();this.dataset.ready='true';
  }
  async select(index){
    if(!this.buttons.some(button=>button.dataset.variantButton===index))return;
    const sequence=++this.sequence;if(this.dataset.selected===index){this.removeAttribute('aria-busy');return;}
    this.setAttribute('aria-busy','true');let timer;
    const images=[...this.querySelectorAll('.ec-image-panel[data-variant-panel="'+index+'"] img')];
    await Promise.race([Promise.allSettled(images.map(img=>{img.loading='eager';return img.decode();})),new Promise(resolve=>{timer=setTimeout(resolve,5000);})]);clearTimeout(timer);
    if(!this.isConnected||sequence!==this.sequence)return;
    this.dataset.selected=index;this.panels.forEach(panel=>{const active=panel.dataset.variantPanel===index;panel.dataset.visible=String(active);panel.setAttribute('aria-hidden',String(!active));});
    this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.variantButton===index)));
    this.querySelector('.ec-status').textContent=this.buttons.find(button=>button.dataset.variantButton===index).getAttribute('aria-label');this.removeAttribute('aria-busy');
  }
  disconnectedCallback(){this.sequence=(this.sequence||0)+1;this.events?.abort();this.events=null;this.readyObserver?.disconnect();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oppo-find-x10-cpu"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oppo-performance-scroll')) {
  customElements.define('oppo-performance-scroll', class extends HTMLElement {
    connectedCallback() {
      const boot = () => {
        if (!this.isConnected || this.events || !this.querySelector('[data-ps-end]')) return;
        this.readyObserver?.disconnect(); this.initialize();
      };
      this.readyObserver = new MutationObserver(boot);
      this.readyObserver.observe(this, { childList:true, subtree:true });
      queueMicrotask(boot);
    }
    initialize() {
      this.events = new AbortController();
      const options = { signal:this.events.signal, passive:true };
      this.track = this.querySelector('.ps-track'); this.stage = this.querySelector('.ps-stage');
      this.intro = this.querySelector('.ps-intro'); this.startSlot = this.querySelector('.ps-slot');
      this.heading = this.querySelector('.ps-heading'); this.frame = this.querySelector('.ps-frame');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
      let node; while ((node = walker.nextNode())) node.nodeValue = node.nodeValue.normalize('NFC');
      this.host = window; let blocked = false;
      for (let parent = this.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
        const overflow = getComputedStyle(parent).overflowY;
        if (/auto|scroll/.test(overflow)) { this.host = parent; break; }
        if (overflow === 'hidden') blocked = true;
      }
      this.dataset.pin = blocked ? 'manual' : 'native';
      this.queue = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.paint(); });
      };
      this.resize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => { if (this.isConnected) this.measure(); }, 100);
      };
      this.host.addEventListener('scroll', this.queue, options);
      if (this.host !== window) window.addEventListener('scroll', this.queue, options);
      window.addEventListener('resize', this.resize, options);
      this.motion.addEventListener('change', this.resize, options);
      this.observer = new ResizeObserver(entries => {
        if (Math.abs(entries[0].contentRect.width - (this.width || 0)) > 1) this.resize();
      });
      this.observer.observe(this);
      document.fonts?.ready.then(() => { if (this.isConnected && this.events) this.measure(); });
      this.measure(); this.dataset.ready = 'true';
    }
    measure() {
      const animated = this.dataset.motion !== 'static' && !(this.dataset.motion === 'system' && this.motion.matches);
      this.classList.toggle('ps-animated', animated);
      this.animated = animated;
      if (!animated) {
        this.frame.removeAttribute('style'); this.stage.removeAttribute('style');
        this.heading?.removeAttribute('style'); this.dataset.progress = '1'; return;
      }
      const width = this.clientWidth;
      if (!width) return;
      const mobile = width < 750;
      const viewport = this.host === window ? window.innerHeight : this.host.clientHeight;
      // Ignore small mobile browser toolbar changes; preserve the scroll timeline.
      if (!this.viewport || !mobile || Math.abs(width - this.width) > 1 || Math.abs(viewport - this.viewport) > 140) this.viewport = viewport;
      this.width = width;
      this.offset = Math.min(this.viewport * .3, Math.max(0,Number(mobile ? this.dataset.mobileOffset : this.dataset.offset) || 0));
      this.height = Math.max(200,this.viewport - this.offset);
      this.travel = this.height * (Number(this.dataset.distance) || 140) / 100;
      this.hold = this.height * Math.max(0,Number(this.dataset.hold) || 0) / 100;
      this.style.setProperty('--ps-height', this.height + 'px');
      this.style.setProperty('--ps-offset', this.offset + 'px');
      this.style.setProperty('--ps-track-height', this.height + this.travel + this.hold + 'px');
      if (this.heading) {
        this.heading.style.removeProperty('font-size');
        let size = parseFloat(getComputedStyle(this.heading).fontSize);
        for (let i=0; i<14 && this.intro.offsetHeight > this.height * .88 && size>24; i++) {
          size=Math.max(24,size*.9); this.heading.style.fontSize=size+'px';
        }
      }
      const stage = this.stage.getBoundingClientRect(), slot = this.startSlot.getBoundingClientRect();
      this.initial = { x:slot.left-stage.left, y:slot.top-stage.top, w:slot.width, h:slot.height };
      this.radius = parseFloat(getComputedStyle(this).getPropertyValue('--ps-radius')) || 0;
      this.paint();
    }
    paint() {
      if (!this.animated || !this.initial) return;
      const hostTop = this.host === window ? 0 : this.host.getBoundingClientRect().top + this.host.clientTop;
      const distance = hostTop + this.offset - this.track.getBoundingClientRect().top;
      const p = Math.max(0,Math.min(1,distance/this.travel));
      const eased = p*p*(3-2*p), a=this.initial;
      this.frame.style.left = a.x*(1-eased)+'px';
      this.frame.style.top = a.y*(1-eased)+'px';
      this.frame.style.width = a.w+(this.width-a.w)*eased+'px';
      this.frame.style.height = a.h+(this.height-a.h)*eased+'px';
      this.frame.style.borderRadius = this.radius*(1-eased)+'px';
      if (this.heading) {
        this.heading.style.opacity = Math.max(0,1-p/.3);
        this.heading.style.transform = 'translateY('+(-40*p)+'px)';
      }
      if (this.dataset.pin === 'manual') this.stage.style.transform='translate3d(0,'+Math.max(0,Math.min(this.travel+this.hold,distance))+'px,0)';
      this.dataset.progress=p.toFixed(4);
    }
    disconnectedCallback() {
      this.events?.abort(); this.events=null; this.observer?.disconnect(); this.readyObserver?.disconnect();
      cancelAnimationFrame(this.raf); this.raf=0; clearTimeout(this.resizeTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oppo-find-x10-kit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oppo-teleconverter-story')) {
  customElements.define('oppo-teleconverter-story', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this._events) this.initialize(); });
    }
    disconnectedCallback() {
      this._events?.abort();
      this._events = null;
    }
    initialize() {
      this._events = new AbortController();
      const options = { signal: this._events.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-tc-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-tc-panel]'));
      this.zoomButtons = Array.from(this.querySelectorAll('[data-tc-zoom]'));
      this.zoomFrames = Array.from(this.querySelectorAll('[data-tc-zoom-frame]'));
      // Normalize text nodes only. Never rewrite innerHTML or split accented letters.
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (!node.parentElement.closest('script,style') && node.nodeValue.normalize) {
          node.nodeValue = node.nodeValue.normalize('NFC');
        }
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled) return;
        if (button.dataset.tcTab) this.setTab(button.dataset.tcTab);
        if (button.dataset.tcZoom) this.setZoom(button.dataset.tcZoom);
      }, options);
      this.addEventListener('keydown', event => {
        const button = event.target.closest('[data-tc-tab], [data-tc-zoom]');
        if (!button) return;
        const isZoom = button.hasAttribute('data-tc-zoom');
        const list = isZoom ? this.zoomButtons.filter(item => !item.disabled) : this.tabs;
        const index = list.indexOf(button);
        if (index < 0) return;
        const next = ['ArrowDown','ArrowRight'].includes(event.key);
        const previous = ['ArrowUp','ArrowLeft'].includes(event.key);
        if (!next && !previous && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        let target = event.key === 'Home' ? 0 : event.key === 'End' ? list.length - 1 : (index + (next ? 1 : -1) + list.length) % list.length;
        list[target].focus();
        if (isZoom) this.setZoom(list[target].dataset.tcZoom);
      }, options);
      const handleError = image => {
        if (image.matches('[data-tc-overlay]')) image.parentElement.hidden = true;
        if (image.matches('[data-tc-image]')) {
          image.parentElement.setAttribute('data-image-error','');
          image.parentElement.classList.add('tc-media-error');
        }
      };
      this.addEventListener('error', event => {
        if (event.target instanceof HTMLImageElement) handleError(event.target);
      }, { ...options, capture: true });
      this.querySelectorAll('img[data-tc-image],img[data-tc-overlay]').forEach(image => {
        if (image.complete && !image.naturalWidth) handleError(image);
      });
      this.classList.add('is-ready');
    }
    setTab(value) {
      this.tabs.forEach(button => {
        const active = button.dataset.tcTab === value;
        button.setAttribute('aria-expanded', String(active));
        button.closest('[data-tc-item]').classList.toggle('is-active', active);
      });
      this.querySelectorAll('[data-tc-copy]').forEach(copy => { copy.hidden = copy.dataset.tcCopy !== value; });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.tcPanel !== value; });
      if (value === '2') this.querySelectorAll('[data-tc-zoom-frame] img').forEach(image => { image.loading = 'eager'; });
    }
    setZoom(value) {
      const target = this.zoomButtons.find(button => button.dataset.tcZoom === value);
      if (!target || target.disabled) return;
      this.zoomButtons.forEach(button => { button.setAttribute('aria-pressed', String(button === target)); });
      this.zoomFrames.forEach(frame => { frame.hidden = frame.dataset.tcZoomFrame !== value; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oppo-find-x10-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oppo-find-x10-promax-product')) {
  customElements.define('oppo-find-x10-promax-product', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.events) this.initialize(); });
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null;
      this.observer?.disconnect(); this.requestId = (this.requestId || 0) + 1;
    }
    initialize() {
      this.events = new AbortController();
      this.requestId = 0;
      const options = { signal:this.events.signal };
      this.buttons = [...this.querySelectorAll('[data-cm-color]')];
      this.layers = [...this.querySelectorAll('[data-cm-layer]')];
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) node.nodeValue = node.nodeValue.normalize('NFC');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-cm-color]');
        if (button && this.contains(button)) this.selectColor(button.dataset.cmColor);
      }, options);
      this.addEventListener('keydown', event => {
        const button = event.target.closest('[data-cm-color]');
        if (!button) return;
        const index = this.buttons.indexOf(button);
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
        this.buttons[next].focus(); this.selectColor(this.buttons[next].dataset.cmColor);
      }, options);
      this.addEventListener('error', event => {
        if (event.target instanceof HTMLImageElement) {
          event.target.hidden = true;
          event.target.closest('[data-cm-layer]')?.setAttribute('data-missing-image','');
        }
      }, { ...options, capture:true });
      this.querySelectorAll('img').forEach(img => {
        if (img.complete && !img.naturalWidth) {
          img.hidden = true;
          img.closest('[data-cm-layer]')?.setAttribute('data-missing-image','');
        }
      });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        this.observer.disconnect();
      }, { rootMargin:'300px' });
      this.observer.observe(this);
      this.classList.add('is-ready');
    }
    async selectColor(value) {
      if (!this.buttons.some(button => button.dataset.cmColor === value)) return;
      const requestId = ++this.requestId;
      if (this.dataset.color === value) { this.removeAttribute('aria-busy'); return; }
      this.setAttribute('aria-busy','true');
      const images = [...this.querySelectorAll('[data-cm-layer="' + value + '"] img')];
      let timeout;
      await Promise.race([
        Promise.allSettled(images.map(img => { img.loading = 'eager'; return img.decode(); })),
        new Promise(resolve => { timeout = setTimeout(resolve, 6000); })
      ]);
      clearTimeout(timeout);
      if (!this.isConnected || requestId !== this.requestId) return;
      this.dataset.color = value;
      this.layers.forEach(layer => layer.setAttribute('aria-hidden', String(layer.dataset.cmLayer !== value)));
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cmColor === value)));
      this.querySelector('[data-cm-status]').textContent = this.buttons.find(button => button.dataset.cmColor === value).getAttribute('aria-label');
      this.removeAttribute('aria-busy');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
